export default [{
  header: 'Solicitud de Materiales',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: { name: 'new-material-request', params: { wizard: 'numOf' } },
      name: 'Crear solicitud',
      icon: 'ClipboardIcon',
      slug: 'panel',
      permiso: '*' // TODO: set permission
    },
    {
      url: { name: 'material-requests', params: { view: 'general' } },
      name: 'Listado de Solicitudes',
      icon: 'FolderIcon',
      slug: 'panel',
      permiso: '*' // TODO: set permission
    },
    {
      url: { name: 'catalogs-maintenance', params: { view: 'general' } },
      name: 'Configuración Catálogo',
      icon: 'LayersIcon',
      permiso: '*' // TODO: set permission
    },
    {
      url: { name: 'material-maintenance', params: { view: 'general' } },
      name: 'Configuración Materiales',
      icon: 'ArchiveIcon',
      permiso: '*' // TODO: set permission
    },
    {
      url: { name: 'entity-management', params: { view: 'general' } },
      name: 'Configuración Entidades',
      icon: 'UserIcon',
      slug: 'panel',
      permiso: '*' // TODO: set permission
    },
  ]
}];
